import { GoHome } from 'components/core-v2'

import { COPY } from '../constants'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'

export const NotFound = () => (
  <TwoColumnWithImage
    centered
    mainElement={<GoHome />}
    showLogo={false}
    title={COPY.notFound.title}
  />
)
